import {
  Component,
  OnInit,
  Input,
  ViewChild,
  OnDestroy,
  OnChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import { takeUntil } from 'rxjs/operators';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

@Component({
  selector: 'app-chips-autocomplete',
  templateUrl: './chips-autocomplete.component.html',
  styleUrls: ['./chips-autocomplete.component.scss'],
})
export class ChipsAutocompleteComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() data: Array<any>;
  @Input() form;
  @Input() control: string;
  @Input() label: string;
  @Input() val2complete: string;
  @Input() placeholderLabel = 'Requisition';

  /** control for the selected bank for multi-selection */
  public bankMultiCtrl: FormControl = new FormControl();

  /** control for the MatSelect filter keyword multi-selection */
  public bankMultiFilterCtrl: FormControl = new FormControl();

  /** list of banks filtered by search keyword for multi-selection */
  public filteredBanksMulti: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  @ViewChild('singleSelect') singleSelect: MatSelect;

  /** Subject that emits when the component has been destroyed. */
  // tslint:disable-next-line:variable-name
  private _onDestroy = new Subject<void>();

  ngOnInit() {
    // load the initial bank list
    if (!_isEmpty(this.data)) {
      this.filteredBanksMulti.next(this.data.slice());
    }

    // listen for search field value changes
    this.bankMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanksMulti();
      });
  }
  ngOnChanges(changes) {
    // load the initial bank list
    const currentValueData = _get(changes, 'data.currentValue', []);
    if (!_isEmpty(currentValueData)) {
      this.filteredBanksMulti.next(currentValueData.slice());
    }

    // listen for search field value changes
    this.bankMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanksMulti();
      });
  }

  ngOnDestroy() {
    this._onDestroy.next(null);
    this._onDestroy.complete();
  }

  private filterBanksMulti() {
    if (!this.data) {
      return;
    }
    // get the search keyword
    let search = this.bankMultiFilterCtrl.value;
    if (!search) {
      this.filteredBanksMulti.next(this.data.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredBanksMulti.next(
      this.data.filter((bank) => {
        if (this.val2complete) {
          return bank[this.val2complete].toLowerCase().indexOf(search) > -1;
        } else {
          return bank.toLowerCase().indexOf(search) > -1;
        }
      })
    );
  }
}
